import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaperPlaneRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_14842_8733)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M10.125 14.375L15 9.5",
			stroke: "#4D4D4D",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M20.9709 4.4544C21.007 4.32611 21.0083 4.1905 20.9747 4.06153C20.941 3.93256 20.8736 3.8149 20.7793 3.72065C20.6851 3.6264 20.5674 3.55897 20.4384 3.5253C20.3095 3.49163 20.1739 3.49294 20.0456 3.52909L2.04556 8.98722C1.8986 9.02869 1.76781 9.11403 1.67066 9.23183C1.5735 9.34964 1.51462 9.49429 1.50188 9.64645C1.48914 9.79861 1.52315 9.95104 1.59936 10.0834C1.67558 10.2157 1.79036 10.3216 1.92837 10.3869L10.1249 14.375L14.1131 22.5707C14.1784 22.7087 14.2843 22.8235 14.4166 22.8997C14.5489 22.9759 14.7014 23.0099 14.8535 22.9971C15.0057 22.9844 15.1503 22.9255 15.2681 22.8284C15.3859 22.7312 15.4713 22.6004 15.5127 22.4535L20.9709 4.4544Z",
			stroke: "#4D4D4D",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14842_8733",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgPaperPlaneRight;
